import { Outlet } from 'react-router-dom'

import Eighthgrade_k8_subjects from './eighthgrade_k8_subjects.jsx';
import TopNavbar from '../../components/TopNavbar.jsx';
import Learning_us_states from '../learning_us_states.jsx';
import California_classes from './california_classes.jsx';


const Eighthgrade_k8 = ( ) => {
 
  return (
    <>
   
   
   <TopNavbar />
   <Learning_us_states />
   <California_classes />
  <Eighthgrade_k8_subjects />  
  
     <Outlet />
    
     </>

  )
}

export default Eighthgrade_k8;